var replaceEmoji = require('./lib/replaceEmoji'),
	makeTwemojiRenderer = require('./lib/makeTwemojiRenderer')

module.exports = function reactEasyEmoji (element, optionsOrFn) {
	var render = (typeof optionsOrFn === 'function') ? optionsOrFn : makeTwemojiRenderer(optionsOrFn)
	return replaceEmoji(element, render)
}


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/react-easy-emoji/index.js
// module id = 285
// module chunks = 0